"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.rawNote = exports.notes = void 0;
var segments = [
    {
        start: 0,
        end: 50,
        text: "CT ANGIO ABDOMEN/PELVIS WITH AND WITHOUT CONTRAST "
    },
    { start: 51, end: 51, text: "" },
    {
        start: 52,
        end: 103,
        text: "ABDOMINOPELVIC CTA WITH AND WITHOUT IV CONTRAST.   "
    },
    { start: 104, end: 106, text: "  " },
    {
        start: 107,
        end: 430,
        text: "TECHNIQUE: Helically acquired axial images from the dome of the diaphragm to the femoral area were obtained without oral or IV contrast, followed by helically acquired axial images from the  diaphragm to the femoral area during the dynamic IV injection of contrast. 2 min delayed images were obtained from the same area.   "
    },
    { start: 431, end: 431, text: "" },
    {
        start: 432,
        end: 528,
        text: "3D IMAGES WITH REFORMATTING AND POST-PROCESSING RECONSTRUCTIONS WERE PERFORMED AND INTERPRETED. "
    },
    { start: 529, end: 529, text: "" },
    {
        start: 530,
        end: 604,
        text: "COMPARISON: CT ANGIO ABDOMEN/PELVIS WITH AND WITHOUT CONTRAST 2016-Dec-19 "
    },
    { start: 605, end: 605, text: "" },
    { start: 606, end: 617, text: "FINDINGS:  " },
    { start: 618, end: 618, text: "" },
    { start: 619, end: 629, text: "VASCULAR: " },
    { start: 630, end: 630, text: "" },
    {
        start: 631,
        end: 811,
        text: "The patient is status post infrarenal abdominal aortic endograft placement, with the proximal attachment at the suprarenal level, and distal  within the left common iliac artery.  "
    },
    {
        start: 812,
        end: 904,
        text: "No endoleaks are detected. When compared to prior exam there is no signs of stent migration "
    },
    { start: 905, end: 905, text: "" },
    {
        start: 906,
        end: 1224,
        text: "Again noted is occlusion of the right common iliac artery, with distal reconstitution at the level of the bifurcation. Redemonstration the right arterial presacral collaterals. Again seen are extensive atherosclerotic calcifications in the right external and internal iliac arteries, with scattered areas of stenosis. "
    },
    { start: 1225, end: 1225, text: "" },
    {
        start: 1226,
        end: 1407,
        text: "There are moderate calcified and noncalcified atherosclerotic plaques in the aorta and its major branches.  There is no evidence of a flap within the aorta to suggest a dissection. "
    },
    { start: 1408, end: 1408, text: "" },
    {
        start: 1409,
        end: 1468,
        text: "The celiac artery and SMA are patent. The IMA is excluded. "
    },
    {
        start: 1469,
        end: 1576,
        text: "There are single renal artery bilaterally. They are widely patent without signs of significant stenosis.   "
    },
    { start: 1577, end: 1577, text: "" },
    {
        start: 1578,
        end: 1670,
        text: "The aortoiliac system is patent without significant stenosis. There is no vein thrombosis.  "
    },
    { start: 1671, end: 1671, text: "" },
    { start: 1672, end: 1686, text: "NON VASCULAR: " },
    {
        start: 1687,
        end: 1912,
        text: "LOWER THORAX: There is diffuse bronchial wall thickening with areas of mucosal plugging and scattered groundglass opacities the right middle and lower lobes, suggestive of aspiration. There is a moderate-sized hiatal hernia. "
    },
    { start: 1913, end: 1913, text: "" },
    {
        start: 1914,
        end: 1986,
        text: "HEPATOBILIARY: No focal hepatic lesions.  No biliary ductal dilatation. "
    },
    { start: 1987, end: 2012, text: "SPLEEN: No splenomegaly. " },
    {
        start: 2013,
        end: 2061,
        text: "PANCREAS: No focal masses or ductal dilatation. "
    },
    { start: 2062, end: 2062, text: "" },
    { start: 2063, end: 2093, text: "ADRENALS: No adrenal nodules. " },
    {
        start: 2094,
        end: 2261,
        text: "KIDNEYS/URETERS: No hydronephrosis, stones, or solid mass lesions. Again seen are unchanged scattered hypodensities throughout the kidneys, too small to characterize. "
    },
    {
        start: 2262,
        end: 2356,
        text: "PELVIC ORGANS/BLADDER: There is diffuse bladder wall thickening and pericystic fat stranding. "
    },
    { start: 2357, end: 2357, text: "" },
    {
        start: 2358,
        end: 2410,
        text: "PERITONEUM / RETROPERITONEUM: No free air or fluid. "
    },
    { start: 2411, end: 2444, text: "LYMPH NODES: No lymphadenopathy. " },
    { start: 2445, end: 2445, text: "" },
    {
        start: 2446,
        end: 2520,
        text: "GI TRACT: No distention or wall thickening. The appendix is unremarkable. "
    },
    { start: 2521, end: 2521, text: "" },
    {
        start: 2522,
        end: 2845,
        text: "BONES AND SOFT TISSUES: There are postoperative changes from left total hip arthroplasty and fixation of the right femur. There are multiple healed fractures in bilateral lower ribs. There are discogenic degenerative changes, most prominently seen at L1-2 disc space. There is a right small fat-containing inguinal hernia. "
    },
    { start: 2846, end: 2846, text: "" },
    { start: 2847, end: 2859, text: "IMPRESSION: " },
    {
        start: 2860,
        end: 2918,
        text: "Status post abdominal aorta endograft, stable since 2016. "
    },
    { start: 2919, end: 2919, text: "" },
    {
        start: 2920,
        end: 2962,
        text: "CT findings suggestive of acute cystitis. "
    },
    { start: 2963, end: 2963, text: "" },
    {
        start: 2964,
        end: 3125,
        text: "Diffuse bronchial wall thickening with areas of mucosal plugging and scattered groundglass opacities the right middle and lower lobes, suggestive of aspiration. "
    },
    { start: 3126, end: 3126, text: "" },
    {
        start: 3127,
        end: 3321,
        text: "ATTESTATION: I, Dr. Laura L. Avery, MD as teaching physician, have reviewed the images for this case and if necessary edited the report originally created by Dr. Maria Gabriela Figueiro Longo.  "
    },
    { start: 3322, end: 3322, text: "" },
    { start: 3323, end: 3339, text: "Interpreted by: " },
    { start: 3340, end: 3363, text: "Laura Louise Avery, MD " },
    { start: 3364, end: 3398, text: "Maria Gabriela Figueiro Longo, MD " },
    { start: 3399, end: 3399, text: "" },
    { start: 3400, end: 3411, text: "Signed by: " },
    { start: 3412, end: 3435, text: "Laura Louise Avery, MD " },
    { start: 3436, end: 3444, text: "4/23/20 " },
    { start: 3445, end: 3445, text: "" },
    { start: 3446, end: 3461, text: "CC Recipients: " },
    {
        start: 3462,
        end: 3514,
        text: "David A Peak, MD - In Basket (authorizing provider) "
    },
    { start: 3515, end: 3515, text: "" },
    { start: 3516, end: 3528, text: "Final result" }
];
exports.notes = [
    {
        description: "Note1. XR KNEE STANDING (BILATERAL",
        content: "",
        segments: segments,
        filename: "note2.txt",
        type: "PREPROCESSED",
        document_id: 234325,
        id: null
    },
    {
        description: "XR KNEE STANDING (BILATERAL",
        content: "Note2. This is the content of note 2. It contains contrast.",
        id: null,
        segments: [
            {
                text: "This is the content of note 2. It contains contrast.",
                start: 0,
                end: 60
            }
        ],
        filename: "note1.txt",
        type: "RAW",
        document_id: 234324
    }
];
exports.rawNote = {
    document_id: 692808,
    description: null,
    content: "INDICATION FOR EXAM:\n Screening.\n  \n PROCEDURE:",
    filename: null,
    type: "RAW",
    id: null
};
//# sourceMappingURL=notes.js.map